$("#menu-toggle").on("click", function () {
  $("#header-menu").toggleClass("is-active");
});

$("#menu-close").on("click", function () {
  $("#header-menu").removeClass("is-active");
});
